<template>
    <div v-if="activeTeam" class="row flex-nowrap border-bottom m-0 header-wrap">
        <div class="col-lg-8 col-md-7 col-sm-2 col-2 align-self-center text-left pr-0">
            <button @click="showPanel" class="p-2 border rounded m-0" id="burger-menu">
                <i class="fa fa-grip-lines"></i>
            </button>
            <HeaderRoutes id="desktop-routes" class="m-0"/>
        </div>
        <div class="col-lg-4 col-md-5 col-sm-10 col-10 align-self-center">
            <HeaderAppSettings class="text-right"/>
        </div>

        <div @click.capture="hidePanel"
             ref="mobileMenu"
             id="mobile-menu"
             class="border-right">
            <a @click.prevent="hidePanel" class="close-btn">×</a>

            <HeaderRoutes mobile class="text-left"/>

        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import HeaderRoutes from './HeaderRoutes'
import HeaderAppSettings from './HeaderAppSettings'

export default {
    name: 'Header',
    components: {HeaderAppSettings, HeaderRoutes},
    computed: {
        ...mapGetters([
            'activeTeam'
        ])
    },
    methods: {
        showPanel() {
            this.$refs.mobileMenu.style.left = '0px'
            this.$refs.mobileMenu.focus()
        },
        hidePanel() {
            this.$refs.mobileMenu.style.left = '-100vw'
        }
    }
}
</script>

<style scoped lang="scss">
    #burger-menu {
        @include media-breakpoint-up(md) {
            display: none;
        }
    }

    #desktop-routes {
        @include media-breakpoint-down(sm) {
            display: none;
        }
    }

    #mobile-menu {
        position: fixed;
        top: 0;
        left: -100vw;
        width: 100vw;
        height: 100vh;
        background: white;
        z-index: 10000;
        transition: 0.5s;
        padding: 40px 30px 30px;

        .close-btn {
            position: absolute;
            top: 0;
            right: 25px;
            font-size: 36px;

            &:hover {
                cursor: pointer;
            }
        }
    }

    .header-wrap {
        min-height: 60px;
        z-index: 10;
        background: white;
    }
</style>
